__turbopack_context__.v({
  "fullWidth": "ColorizedPanel-module-scss-module__GZQJbG__fullWidth",
});
